import { CheckCircle, Circle, Lightning, Warning } from "@phosphor-icons/react";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import type { KeyStatus } from "../types";

interface StatusConfig {
  label: string;
  tone: "success" | "warning" | "error" | "muted";
  Icon: React.ElementType;
  spinnerClass?: string;
}

const COPY: Record<KeyStatus, StatusConfig> = {
  pending: {
    label: "Verificando...",
    tone: "muted",
    Icon: Circle,
    spinnerClass: "animate-spin",
  },
  valid: {
    label: "Ativa",
    tone: "success",
    Icon: CheckCircle,
  },
  invalid_auth: {
    label: "Chave inválida",
    tone: "error",
    Icon: Warning,
  },
  quota_exhausted: {
    label: "Cota esgotada",
    tone: "warning",
    Icon: Lightning,
  },
  rate_limited: {
    label: "Rate limit",
    tone: "warning",
    Icon: Lightning,
  },
  unknown_error: {
    label: "Erro desconhecido",
    tone: "error",
    Icon: Warning,
  },
};

const TONE_CLASS: Record<"success" | "warning" | "error" | "muted", string> = {
  success: "bg-green-500/15 text-green-400 border-green-500/30",
  warning: "bg-warning/15 text-yellow-400 border-warning/30",
  error: "bg-destructive/15 text-red-400 border-destructive/30",
  muted: "bg-muted text-muted-foreground border-border",
};

export function StatusBadge({ status }: { status: KeyStatus }) {
  const { label, tone, Icon, spinnerClass } = COPY[status];
  return (
    <Badge
      variant="outline"
      className={cn("flex items-center gap-1.5", TONE_CLASS[tone])}
      aria-label={`Status: ${label}`}
    >
      <Icon weight="bold" className={cn("w-3.5 h-3.5", spinnerClass)} aria-hidden="true" />
      {label}
    </Badge>
  );
}
